import cx from 'classnames';
import Trans from 'next-translate/Trans';
import useTranslation from 'next-translate/useTranslation';
import {
  FunctionComponent,
  useEffect,
  useRef,
  useState,
} from 'react';

import useLinkProps from '../../../hooks/use-link-props';
import useLoggedUser from '../../../hooks/use-logged-user';
import { useAppContext } from '../../providers/app-context';

const PriceInfo: FunctionComponent<{
  productDetail: TProductDetail;
  hasEurop: boolean;
  actState?: 'ADDED' | undefined;
  isSold?: boolean;
}> = ({ productDetail, hasEurop, actState, isSold }) => {
  const { detailedPrice: hasDetailedPrice } = useAppContext();
  const { t } = useTranslation();
  const [showMobile, setShowMobile] = useState(false);
  const ref = useRef();
  const user = useLoggedUser();
  const getLink = useLinkProps();
  const isResaleer = user?.staff.company_type == 'supplier';

  useEffect(() => {
    const watcher: IntersectionObserverCallback = (entries) => {
      setShowMobile(!entries[0].intersectionRatio);
    };

    const options = {
      root: null,
      rootMargin: '0px',
      threshold: 0,
    };

    let observer: IntersectionObserver;

    if (typeof IntersectionObserver !== 'undefined') {
      observer = new IntersectionObserver(watcher, options);

      ref?.current && observer.observe(ref?.current);
    }

    return () => {
      if (observer) {
        observer.disconnect();
      }
    };
  }, [ref]);

  return (
    <>
      <div id="product-info" className={cx('grid max-lg:px-4')}>
        <div ref={ref} className={cx('grid  gap-4', 'grid-rows-1')}>
          <div className={cx('grid', 'gap-2', 'lg:grid-cols-1')}>
            <div className="flex flex-row gap-4 justify-end items-end">
              <div
                className={cx('lg:pr-0', {
                  'lg:pt-1.5 col-start-2': !productDetail?.warranty,
                })}
              >
                <div
                  className={cx(
                    'text-right',
                    'font-bold',
                    'text-lg',
                    'leading-5',
                    'text-neutral-80'
                  )}
                  data-cy="price"
                >
                  {productDetail?.pricing?.price_final_printable
                    ? hasDetailedPrice
                      ? productDetail?.pricing?.details
                        ?.product_price_in_currency_printable
                      : productDetail?.pricing?.price_final_printable
                    : productDetail?.status !== 'SOL'
                      ? t('product:price_on_request')
                      : ''}
                </div>
                <div
                  className={cx(
                    'text-right',
                    'font-bold',
                    'text-sm',
                    'leading-5',
                    'text-neutral-80'
                  )}
                  data-cy="price"
                >
                  {hasDetailedPrice
                    ? productDetail?.pricing?.details
                      ?.product_price_in_default_currency_printable
                    : productDetail?.pricing
                      ?.price_in_default_currency_printable}
                </div>
              </div>
            </div>
            {
              productDetail?.pricing?.price_final_printable && (
                <div
                  className={cx(
                    'text-right',
                    'text-xs',
                    isResaleer ? 'text-red-100' : 'text-neutral-80'
                  )}
                >
                  {isResaleer ? (
                    t('product:resale_price')
                  ) : hasDetailedPrice ? (
                    <Trans
                      i18nKey={`product:checklist.tax_included_if_applicable`}
                      components={{ b: <b /> }}
                    />
                  ) : (
                    <Trans
                      i18nKey={`product:checklist.vat_shipping_${productDetail?.pricing?.price_message}`}
                      components={{ b: <b /> }}
                    />
                  )}
                </div>
              )}
          </div>
        </div>
      </div>

      {/*isMobile && productDetail?.status !== 'SOL' && (
        <MobilePriceInfo isOpen={!showMobile} productDetail={productDetail} />
      )*/}
    </>
  );
};

export default PriceInfo;
